import HeaderBar from "../../../Components/UI/headerbar";
import QuickOffersTab from "../components/QuickOffersTab";


const QuickOffersPage = () => {

  return (
    <div className="container-fluid">
      <HeaderBar title="التسويق" content="إدارة الكوبونات والعروض والبانرات." />

      <div className="mt-4">
        <QuickOffersTab />
      </div>
    </div>
  );
};

export default QuickOffersPage;
